import React from 'react';
import FieldError from './FieldError';

interface EmailInputProps {
    value: string;
    error: string;
    onChange: (value: string) => void;
    onBlur: () => void;
}

const EmailInput: React.FC<EmailInputProps> = ({ value, error, onChange, onBlur }) => (
    <div className="cf-field">
        <input
            type="email"
            className={`cf-input${error ? ' cf-input--error' : ''}`}
            placeholder="אימייל"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            id="cf-email"
            dir="ltr"
        />
        <FieldError message={error} />
    </div>
);

export default EmailInput;
